module.exports = __webpack_public_path__ + "static/media/Lomowebpixel-01.384d944b.svg";